import React from 'react';
import { NoPerms } from '../../Components/Error/noPerms';

const _AccessDeniedPage = () => {
  return (
      <NoPerms />
  );
};
const AccessDeniedPage = React.memo(_AccessDeniedPage);
export { AccessDeniedPage };
export default AccessDeniedPage;
